import ApiService from '../api.service';

const Reports = {
  create: (params) => ApiService.post(`api/v2/teachers/me/posts/${params.post_id}/reports`, params),
};

export default Reports;
